import type { CSSObject } from '@emotion/react'
import { Size, Spacing } from '@opallabs/gem'
import { fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

type AssetPickerWrapper = (arg: {
  style: CSSObject
  dragging: boolean
  borderRadius: string | undefined
}) => CSSObject

const getAssetPickerWrapper: AssetPickerWrapper = ({
  style,
  dragging,
  borderRadius,
}): CSSObject => ({
  ...style,
  position: 'relative',
  alignItems: 'center',
  backgroundColor: colors.n8.base,
  color: colors.n4.base,
  display: dragging ? 'flex' : 'block',
  fontSize: fontSizes.medium,
  justifyContent: 'center',
  '&:after': {
    blockSize: 'calc(100% - 20px)',
    border: `dashed 2px ${colors.n4.base}`,
    borderRadius: borderRadius ? borderRadius : Size.Rounding,
    boxSizing: 'border-box',
    content: "''",
    display: dragging ? 'block' : 'none',
    inlineSize: 'calc(100% - 20px)',
    insetBlockStart: Spacing.S * 1.25,
    insetInlineStart: Spacing.S * 1.25,
    padding: Spacing.S * 1.25,
    position: 'absolute',
  },
})

const assetPickerBtnWrapper: CSSObject = {
  padding: Spacing.S * 1.25,
}

const assetPickerBtnGroup: CSSObject = {
  border: `2px solid ${colors.n5.base}`,
  borderRadius: Size.Rounding,
  cursor: 'pointer',
  inlineSize: Spacing.M * 2,
  '&:hover': {
    border: `2px solid ${colors.n3.base}`,
    '.kuiper-asset-picker-plus': {
      backgroundColor: `${colors.n3.base} !important`,
      color: colors.n10.base,
    },
    '.kuiper-icon-asset-library': {
      color: colors.n3.base,
    },
  },
}

const assetPickerBtn: CSSObject = {
  alignItems: 'center',
  blockSize: Spacing.M * 2,
  display: 'flex',
  inlineSize: Spacing.M * 2,
  justifyContent: 'center',
}

const assetPickerBtnPlus: CSSObject = {
  ...assetPickerBtn,
  backgroundColor: colors.n5.base,
  color: colors.n9.base,
}

const assetPickerBtnAssetLibrary: CSSObject = {
  ...assetPickerBtn,
  backgroundColor: colors.n8.base,
  color: colors.n5.base,
}

const styles = {
  getAssetPickerWrapper,
  assetPickerBtnWrapper,
  assetPickerBtnGroup,
  assetPickerBtnPlus,
  assetPickerBtnAssetLibrary,
}

export { styles }
